module.exports = function() {
  this.page = 1;
  return Math.ceil(this.count / this.limit);
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/computed/total-pages.js